/** Normalises API error payloads for feedback request save flows. */
export function normalizeFeedbackRequestError(
  err: unknown,
  fallback: string
): string {
  if (typeof err === "string") {
    return err;
  }
  if (typeof (err as { message?: string })?.message === "string") {
    return (err as { message: string }).message;
  }
  return fallback;
}
